import AuthModal from "legacy/auth/AuthModal"
import PropTypes from "prop-types"
import React from "react"

// Note: Amplitude is loaded globally

class AuthLauncher extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      showModal: false,
    }
    this.launchModal = this.launchModal.bind(this)
    this.textLabel = this.textLabel.bind(this)
  }

  componentDidMount() {
    if (this.props.force) {
      this.launchModal()
    }
  }

  launchModal(event) {
    this.setState({ showModal: true })
    if (this.props.amplitudeEvent) {
      Amplitude.trackEvent(
        this.props.amplitudeEvent.eventName,
        this.props.amplitudeEvent.eventProperties
      )
    }
    event && event.preventDefault()
  }

  textLabel() {
    if (this.props.customLabel) {
      return this.props.customLabel
    } else if (this.props.type === "signup") {
      return "Sign Up"
    } else {
      return "Log In"
    }
  }

  render() {
    return (
      <div className={this.props.customClass}>
        <button
          type="button"
          className="btn btn-danger"
          onClick={this.launchModal}
        >
          {this.textLabel()}
        </button>
        {this.state.showModal && (
          <AuthModal
            initialView={this.props.type}
            closeModal={() => this.setState({ showModal: false })}
          />
        )}
      </div>
    )
  }
}

AuthLauncher.propTypes = {
  amplitudeEvent: PropTypes.shape({
    eventName: PropTypes.string.isRequired,
    eventProperties: PropTypes.object,
  }),
  customClass: PropTypes.string,
  customLabel: PropTypes.string,
  force: PropTypes.bool,
  type: PropTypes.string,
}

AuthLauncher.defaultProps = {
  customClass: "",
  force: false,
  type: "login",
}

export default AuthLauncher
